<template>
  <el-tooltip
    effect="dark"
    placement="top-start"
    :content="AGGRESSIVE_TOOLTIP"
    :disabled="!aggressive"
  >
    <el-button
      size="small"
      class="violations-button ml-1"
      round
      plain
      @click="$emit('click')"
    >
      <span class="violations-button__content">
        <img :src="icon" alt="" class="violations-button__icon" />
        <span>Malware scans</span>
      </span>
    </el-button>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import fire from '@/apps/traforama/assets/icons/fire.png'
import emoji from '@/apps/traforama/assets/icons/emoji.png'

const AGGRESSIVE_TOOLTIP =
  'Due to issues found during ad scanning, traffic volume may be reduced because of publisher settings.'

export default defineComponent({
  name: 'ViolationsButton',
  props: {
    aggressive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props) {
    const icon = computed(() => (props.aggressive ? fire : emoji))

    return { icon, AGGRESSIVE_TOOLTIP }
  }
})
</script>

<style lang="scss" scoped>
.violations-button {
  &.el-button :deep(> span) {
    display: inline-flex;
    align-items: center;
  }

  &__content {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  &__icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    object-fit: contain;
    display: block;
  }
}
</style>
